import { Component, inject } from '@angular/core';
import { CapturumButtonModule } from '@capturum/ui/button';
import { CapturumInputModule } from '@capturum/ui/input';
import { CapturumInputSwitchModule } from '@capturum/ui/input-switch';
import { CapturumPasswordModule } from '@capturum/ui/password';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { LoginComponent } from '@capturum/login';
import { ToastService } from '@capturum/ui/api';
import { AsyncPipe } from '@angular/common';
import { AppRoutes } from '@core/enums/routes.enum';
import { toSignal } from '@angular/core/rxjs-interop';
import { BreakpointService } from '@core/services/breakpoint.service';
import { SESSION_EXPIRED_FLAG } from '@core/constants/session-expired.constant';

@Component({
  selector: 'app-lg-login',
  imports: [
    CapturumButtonModule,
    CapturumInputModule,
    CapturumInputSwitchModule,
    CapturumPasswordModule,
    FormsModule,
    ReactiveFormsModule,
    RouterLink,
    TranslateModule,
    AsyncPipe,
  ],
  templateUrl: './lg-login.component.html',
  styleUrls: ['./lg-login.component.scss'],
})
export class LgLoginComponent extends LoginComponent {
  readonly #router = inject(Router);
  readonly #breakpointService = inject(BreakpointService);
  readonly #toastService = inject(ToastService);
  readonly #translateService = inject(TranslateService);

  public readonly isMobile = toSignal(this.#breakpointService.isMobile$);

  protected readonly AppRoutes = AppRoutes;

  public override ngOnInit(): void {
    super.ngOnInit();
    this.notifyIfSessionExpired();
  }

  public loginSSO(): void {
    this.#router.navigate([AppRoutes.auth, AppRoutes.ssoAllStars]);
  }

  private notifyIfSessionExpired(): void {
    if (!sessionStorage.getItem(SESSION_EXPIRED_FLAG)) {
      return;
    }

    sessionStorage.removeItem(SESSION_EXPIRED_FLAG);

    this.#toastService.info(
      this.#translateService.instant('LeadPortal.auth.session-expired.title'),
      this.#translateService.instant('LeadPortal.auth.session-expired.message')
    );
  }
}
